import React from 'react';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';
import withStyles from '@material-ui/core/styles/withStyles';
import AccountForm from 'components/Account/AccountForm';
import { GET_PATIENT_ACCOUNT } from 'graphql/queries';

const styles = {};

class Account extends React.Component {
  render() {
    const { id } = this.props;

    return (
      <div>
        <Query query={GET_PATIENT_ACCOUNT} variables={{ id }} fetchPolicy="cache-and-network">
          {({ loading, error, data }) => {
            if (loading) return 'Loading...';
            if (error) return `Error! ${error.message}`;

            const { account } = data.getPatient;

            return (
              <div>
                <AccountForm id={id} account={account} />
              </div>
            );
          }}
        </Query>
      </div>
    );
  }
}

Account.propTypes = {
  id: PropTypes.string.isRequired,
};

export default withStyles(styles)(Account);
